module.exports = __webpack_public_path__ + "img/管理@2x.facf3bfe.png";